import React,{useEffect, useState}  from 'react'
import {Box,Typography,Container,Button,Menu,MenuItem, CircularProgress} from '@mui/material'
import {useTheme,styled } from '@mui/material/styles'
import MoreIcon from '@mui/icons-material/MoreVert'
import {IconButton} from "@mui/material"
import Divider from '@mui/material/Divider';
import {useNavigate} from 'react-router-dom'
import { add_test,} from "../Redux/testSlice";
import { add_tests,} from "../Redux/testsSlice";
import Header from '../Components/Header'
import CustomDialog from '../Components/CustomDialog'
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import ItemView from '../Components/ItemView';
import axios from 'axios'
import Snackbar from '@mui/material/Snackbar'
import { CalendarMonth, CopyAll, EditNote, Groups, MailOutlineOutlined, Remove, Timelapse } from '@mui/icons-material';
import delete_tst from '../Redux/reducers/delete_tst';
import delete_user from '../Redux/reducers/delete_user';
import { add_reports } from '../Redux/reportsSlice'
import { add_candidates } from '../Redux/settingSlice'

const QuestionBox = styled(Box, {
})(({ theme}) => ({
	transition: theme.transitions.create('width', {
	easing: theme.transitions.easing.sharp,
	duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 7,
    backgroundColor: '#100101'
  },
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 5
  },
minHeight:300,
maxHeight:450
})
);


const TestInfo = ()=>{


	const theme = useTheme()
	const [level, setLevel] = useState("");
	const navigate = useNavigate()
	const [mailing, setMailing] = useState(false);
	const [deleting, setDeleting] = useState(false);
	const [del, setDel] = useState(false);
	const [open, setOpen] = React.useState(false);
	const [showModal, setShowModal] = React.useState(false);
	const [isNext, setIsNext] = React.useState(false);
	const [message, setMessage] = React.useState("");
	const user = useSelector(state => state?.auth.user);
	const test = useSelector(state => state?.test.test);
	const tests = useSelector(state => state?.tests.tests);
	const [users, setUsers] = React.useState(test?.users || []);
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [mobileAnchorEl, setMobileAnchorEl] = React.useState(null);
	const dispatch = useDispatch()

	const isMenuOpen = Boolean(anchorEl);
	const isApiMenuOpen = Boolean(mobileAnchorEl);

	const menuId = 'primary-search-account-menu';
	const mobileMenuId = 'primary-search-account-menu-mobile';

const handleMobileMenuClose = () => {
	setMobileAnchorEl(null);
};

const handleMenuClose = () => {
	setAnchorEl(null);
	handleMobileMenuClose();
};

const handleMenuOpen = (event) => {
	setAnchorEl(event.currentTarget);
  };


async function handleUserDelete(userData){

try{
	const data = {
		id:test?.id,
		email:userData?.email,
		token:user?.accessToken
	}

	console.log(data)

	await delete_user(data,setOpen,setMessage,setUsers,setDel)

}catch(err){
	console.log(err)
}

}

const renderMenu = (
	<Menu
		anchorEl={anchorEl}
		anchorOrigin={{
		vertical: 'top',
		horizontal: 'right',
		}}
		id={menuId}
		keepMounted
		transformOrigin={{
		vertical: 'top',
		horizontal: 'right',
		}}
		open={isMenuOpen}
		onClose={handleMenuClose}
	>
		{
			test?.owner === user?.email && (
				<>
				<MenuItem sx={{width:250,height:40}} 
					onClick={async (e)=>{
						e?.preventDefault()

						const data = {
							id:test?.id,
							email:user?.email,
							token:user?.accessToken
						}
						
						await delete_tst(data,add_test,add_tests,tests,dispatch,setDeleting,setMessage,setOpen,navigate)
						handleMenuClose()
					}}>
						<IconButton
							size="large"
							aria-label="account of current user"
							aria-controls="primary-search-account-menu"
							aria-haspopup="true"
							color="inherit"
							disabled={deleting ? true : false}
							>
							{
								deleting ? <CircularProgress size={18} sx={{color:"black"}}/> : <Remove fontSize="small" sx={{color:"red"}}/>
							}
						</IconButton>
						<p style={{marginLeft:10,fontSize:12}}>Delete</p>
					</MenuItem>
					<MenuItem sx={{width:250,height:40}} 
						onClick={async (e)=>{
							e?.preventDefault()
							dispatch(add_candidates(test?.users))
							navigate("/sendMail")
							handleMenuClose()
					}}>
						<IconButton
							size="large"
							aria-label="account of current user"
							aria-controls="primary-search-account-menu"
							aria-haspopup="true"
							color="inherit"
							disabled={mailing}
							>
							{
								mailing ? <CircularProgress size={18} sx={{color:"black"}}/> : <MailOutlineOutlined fontSize="small" sx={{color:"red"}}/>
							}
						</IconButton>
						<p style={{marginLeft:10,fontSize:12}}>Send Mail</p>
					</MenuItem>
					<MenuItem sx={{width:250,height:40}} 
						onClick={(e)=>{
							e?.preventDefault()
							dispatch(add_test(test))
							navigate("/editTest")
						}}>
						<IconButton
							size="large"
							aria-label="account of current user"
							aria-controls="primary-search-account-menu"
							aria-haspopup="true"
							color="inherit"
							
							>
							<EditNote sx={{color:"green"}} fontSize="small"/>
						</IconButton>
						<p style={{marginLeft:10,fontSize:12}}>Edit</p>
					</MenuItem>
				</>
			)
		}
		<MenuItem sx={{width:250,height:40}} 
			onClick={(e)=>{
				e?.preventDefault()
				navigator.clipboard.writeText(test?.id)
				setMessage("Assessment code copied")
				setOpen(true)
				handleMenuClose()
			}}>
			<IconButton
				size="large"
				aria-controls="primary-search-account-menu"
				aria-haspopup="true"
				color="inherit"
				>
				<CopyAll sx={{color:"yellow"}} fontSize="small"/>
			</IconButton>
			<p style={{marginLeft:10,fontSize:12}}>Copy Code</p>
		</MenuItem>
	</Menu>
	);
	
const handleSnackbarOpen = ()=>{
	setOpen(true)
}

const handleSnackbarClose = ()=>{
	setOpen(false)
}

const DescriptionText = ({text,limit})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Typography color="white" ml={1} fontSize={13}> {displayText} </Typography>
  }

useEffect(()=>{
  if (test?.owner !== user?.email) {
	navigate("/dashboard")
  }
},[])

	return(
		<Box width="100%">
			<Header title="Create Assessment">
				<Breadcrumbs aria-label="breadcrumb">
					<Link  sx={{fontSize:12,color:"gray"}} underline="hover" color="inherit" href="/dashboard">
						Dashboard
					</Link>
					<Typography sx={{fontSize:12,color:"gray"}}>Test Info </Typography>
			</Breadcrumbs>			
			</Header>
			<Container>
				<Snackbar 
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}} 
					message={message} 
					onClose={handleSnackbarClose} 
					open={open} 
					autoHideDuration={2000}
				/>
					<Box m={1} display="flex" width="95%" flexDirection="row" justifyContent="space-between" alignItems="center">
						<Typography mt={2} ml={2} style={{fontSize:13,fontFamily:"dinofans"}}>
							Assessment Info
						</Typography>
						<Box display="flex" flexDirection="row" justifyContent="flex-end" alignItems="center" width="75%">
							<Button onClick={(e)=>{
								e?.preventDefault()
								navigate("/duplicateTest")
							}} sx={{backgroundColor:"#fff",color:"#000",display:{xs:"none",md:"inline-block"},color:"black",fontFamily:"dinofans",m:1,fontSize:{xs:10,md:12},height:30}} variant="contained">
								DUPLICATE
							</Button>
							<Button  onClick={(e)=>{
								e?.preventDefault()
								dispatch(add_test(test))
								dispatch(add_reports(test?.reports))
								navigate("/testReport")
							}} sx={{backgroundColor:"maroon",display:{xs:"none",md:"inline-block"},color:"gold",fontSize:{xs:10,md:12},height:30,m:1,fontFamily:"dinofans",color:"#fff"}} variant="contained">
								REPORT
							</Button>	
							<Button onClick={(e)=>{
								e?.preventDefault()
								dispatch(add_test(test))
								dispatch(add_reports(test?.reports))
								// if(test?.isRealTime){
								// 	navigate("/tryTest")
								// }else{
									navigate("/tryTest")
								// }
							}} sx={{backgroundColor:"gold",color:"black",fontSize:{xs:10,md:12},height:30,fontFamily:"dinofans",m:1}} variant="contained">
								TRY
							</Button>
							<IconButton onClick={()=>{
								setShowModal(true)
							}}>
								<Typography pr={1} color="white" fontSize={14} >
									{test?.users?.length}
								</Typography>							
								<Groups fontSize='25' style={{color:"gray"}}/>
							</IconButton>	
							<IconButton sx={{display:{xs:"none",md:"inline-block"}}}  onClick={handleMenuOpen}>
								<MoreIcon fontSize="small"/>
							</IconButton>
						</Box>
                        {renderMenu}
					</Box>
					<Box sx={{backgroundColor:"black",borderRadius:5,m:{md:2},padding:2,width:{xs:450,md:"100%",paddingLeft:1}}}>
						<Box display="flex" flexWrap="wrap" justifyContent="space-between" >
							<Box sx={{margin:1,padding:2,color:"gray"}}>
								<Typography sx={{fontFamily:"dinofans",marginBottom:1}}>
									Title
								</Typography>
								<DescriptionText limit={100} text={test?.name} />
							</Box>
							<ItemView title="Questions" content={test?.questions}/>
							<ItemView title="Specialties" content={test?.specialty}/>
							<ItemView title="Fields" content={test?.field}/>
							<ItemView title="Level" content={test?.level}/>
							<ItemView title="Language" content={test?.language}/>
							<Box sx={{display:"flex",flexDirection:"row",justifyContent:"space-evenly",width:"100%",alignContent:"center",marginBottom:3}}>
								<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
									<IconButton>
										<CalendarMonth style={{color:"gray"}}/>
									</IconButton>
									<Typography color="white" fontSize={14} width={80}>
										{test?.start_date}
									</Typography>
								</Box>
								<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
									<IconButton>
										<CalendarMonth style={{color:"gray"}}/>
									</IconButton>
									<Typography color="white" fontSize={14} width={40}>
										{test?.start_moment}
									</Typography>
								</Box>
								<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
									<IconButton>
										<Timelapse style={{color:"gray"}}/>
									</IconButton>
									<Typography color="white" fontSize={14} width={60}>
										{test?.time} min
									</Typography>
								</Box>
							</Box>
							<Box sx={{margin:1,padding:2,color:"gray",width:{md:"85%"}}}>
								<Typography sx={{fontFamily:"dinofans",marginBottom:1}}>
									Description
								</Typography>
								<DescriptionText limit={100} text={test?.description} />
							</Box>
							{
								(test?.testQuestions && test?.testQuestions?.length > 0) && (
									<Box sx={{margin:1,mt:0,padding:1,color:"gray",width:{md:"85%"}}}>
										<Divider sx={{mt:1,mb:1}}/>
										<Typography sx={{fontFamily:"dinofans",marginBottom:1}}>
											test Questions
										</Typography>
										<QuestionBox >
											{test?.testQuestions?.map((item,index)=>(
												<Box key={index} sx={{width:"100%"}}>
														<Typography mt={1}  style={{fontSize:13,color:"#ff0",fontFamily:"dinofans"}}>
															{index+1}. Question
														</Typography>
														<Typography sx={{p:1,fontSize:13}}>
															{item?.question}
														</Typography>
														<Typography mt={1}  style={{fontSize:13,color:"#ff0",fontFamily:"dinofans"}}>
															Type
														</Typography>
														<Typography sx={{p:1,fontSize:13}}>
															{item?.type}
														</Typography>
														<Box width="80%" sx={{mt:1}}>
															<Typography sx={{fontFamily:"dinofans",fontSize:14,color:"#ff0"}}>
																Choices
															</Typography>
															<ol>
																{
																	item?.choices?.map((itm,index)=>(
																		<li style={{color:"#fff",fontSize:12}} key={index}>
																			{itm}
																		</li>
																	))
																}
															</ol>
														</Box>
														<Box width="80%" sx={{mt:1}}>
															<Typography sx={{fontFamily:"dinofans",fontSize:14,color:"#ff0"}}>
																Answers
															</Typography>
															<ol>
																{
																	item?.answers?.map((itm,index)=>(
																		<li style={{color:"#fff",fontSize:12}} key={index}>
																			{itm}
																		</li>
																	))
																}
															</ol>
														</Box>
														<Divider sx={{mt:1,mb:1}}/>
													</Box>
													))
												}
										</QuestionBox>
									</Box>
								)
							}
						</Box>
				</Box>
				<CustomDialog massDisabled={true} visible={showModal} deleting={del} setVisible={setShowModal} handleUserDelete={handleUserDelete} data={users.length > 0 ? users : test?.users}/>
			</Container>
		</Box>
		)
}

export default TestInfo